export enum LanguageResourceType {
  Erp = 1,
  Site = 2,
  DocumentTemplates = 3,
  Products = 4,
}
